import { z } from 'zod';
import { OrgFunctionSchema } from '../../entities/org-function/org-function.schema';
/**
 * Show OrgFunction Request Schema
 * GET /api/v2/orgFunction/:id
 */ export const ShowOrgFunctionRequestSchema = z.object({});
/**
 * Show OrgFunction Response Schema
 * GET /api/v2/orgFunction/:id
 */ export const ShowOrgFunctionResponseSchema = z.object({
    data: OrgFunctionSchema
});

//# sourceMappingURL=show-org-function.schema.js.map